import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Dictionary } from 'lodash';
import { CompetencyTemplate } from 'src/app/common/models/competencyTemplate';
import * as feather from 'feather-icons';
import { MatChipOption } from '@angular/material/chips';
import { CompetencyTemplateService } from 'src/app/common/services/competency-type.service';
import * as _ from 'lodash';
import { ConfirmationDialogComponent, ConfirmDialog } from 'src/app/dialogs/dialog-unsaved-changes/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { PlanEditService } from 'src/app/common/services/plan-edit.service';
import { Competency } from 'src/app/common/models/competency';
import { DialogLearnMoreComponent } from 'src/app/dialogs/dialog-learn-more/dialog-learn-more.component';
import { CompetencyService } from 'src/app/common/services/competency.service';
import { UserService } from 'src/app/common/services/user.service';
import { MatButton } from '@angular/material/button';
import {Constants} from "../../common/constants/constants";

@Component({
    selector: 'app-select-competencies',
    templateUrl: './select-competencies.component.html',
    styleUrls: ['./select-competencies.component.css'],
    standalone: false
})

export class SelectCompetenciesComponent implements AfterViewInit, OnInit {

  private readonly pendingCompetencyNames = new Set<string>();

  @ViewChildren('addCompetency', { read: ElementRef })
  buttons: QueryList<ElementRef<HTMLButtonElement>>;

  @ViewChild('otherCompetencyText', { read: ElementRef })
  text: ElementRef<HTMLTextAreaElement>;

  @ViewChild("errorSection", {read: ElementRef}) errorSection!: ElementRef;

  @Output() workingCompetencyChange = new EventEmitter();

  @Input() competencies: Competency[];
  @Input() savedCompetencies: Competency[];
  @Input() planId: string;
  @Input() nextButton: MatButton;

  showErrors = false;
  addCustomCompetency: string;
  errorMessage: string;

  constructor(private competencyTemplateService: CompetencyTemplateService, private cdr: ChangeDetectorRef, private dialog: MatDialog, private planEditService: PlanEditService, private competencyService: CompetencyService, private userService: UserService) { }

  groupedCompetencies: Dictionary<CompetencyTemplate[]>;
  allCompetencies: CompetencyTemplate[];

  ngOnInit(): void {

    this.competencyTemplateService.getCompetencyTemplatesGrouped()
      .subscribe(data => {
        this.groupedCompetencies = data
        this.cdr.detectChanges();
      });

    this.competencyTemplateService.getCompetencyTemplates()
      .subscribe(data => {
        this.allCompetencies = data;
        const otherCompetencies = this.competencies?.filter(r => r.Domain === 'Other');
        otherCompetencies?.forEach(r => this.allCompetencies.push({Name: r.Name, Domain: r.Domain, Description: '', Checked: null}));
      });
  }

  ngAfterViewInit() {
    feather.replace();
  }

  clickSelection(chip: MatChipOption, domain: string) {
    const selectedCompetency = this.competencies?.find(r => r.Name === chip.value);
    if (selectedCompetency) {
      this.openConfirmationDialog(selectedCompetency, chip);
    } else {
      if (this.pendingCompetencyNames.has(chip.value)) {
        return;
      }
      const saved = this.savedCompetencies?.find(r => r.Name === chip.value);
      if(saved){
        this.openAddExistingSavedCompetencyDialog(saved);
      }else{
      const competency = { Name: chip.value, Domain: domain,
        Id: '0',
        PlanId: this.planId,
        UserId: '0',
        Rating: null,
        ReflectionRating: null,
        ReflectionNotes: null,
        ActivityNote: null,
        Order: this.competencies.length + 1,
        Activities: [],
        Version: this.planEditService.getIsEditing() ? -1 : 0,
        addedFromSavedCompetency: false };
        this.pendingCompetencyNames.add(chip.value);
        this.competencyService.createCompetencyByPlanId(competency, this.planId).subscribe({
          next: (r) => this.competencies.push(r),
          error: () => this.pendingCompetencyNames.delete(chip.value),
          complete: () => this.pendingCompetencyNames.delete(chip.value)
        });
      }
      chip.toggleSelected();
      this.planEditService.setIsDirty(true);
    }
  }

  keyboardSelection($event: Event, chip: MatChipOption, domain: string) {
    $event.stopImmediatePropagation();
    const selectedCompetency = this.competencies?.find(r => r.Name === chip.value);
    if (selectedCompetency) {
      this.openConfirmationDialog(selectedCompetency, chip);
    } else {
      if (this.pendingCompetencyNames.has(chip.value)) {
        return;
      }
      const saved = this.savedCompetencies?.find(r => r.Name === chip.value);
      if(saved){
        this.openAddExistingSavedCompetencyDialog(saved);
      }else{
      const competency = { Name: chip.value, Domain: domain,
        Id: '0',
        PlanId: this.planId,
        UserId: '0',
        Rating: null,
        ReflectionRating: null,
        ReflectionNotes: null,
        ActivityNote: null,
        Order: this.competencies.length + 1,
        Activities: [],
        Version: this.planEditService.getIsEditing() ? -1 : 0,
        addedFromSavedCompetency: false };
        this.pendingCompetencyNames.add(chip.value);
        this.competencyService.createCompetencyByPlanId(competency, this.planId).subscribe({
          next: (r) => this.competencies.push(r),
          error: () => this.pendingCompetencyNames.delete(chip.value),
          complete: () => this.pendingCompetencyNames.delete(chip.value)
        });
      }
      chip.toggleSelected();
      this.planEditService.setIsDirty(true);
    }
  }

  isSelected(chipOrName: MatChipOption | string): boolean {
    const name = typeof chipOrName === 'string' ? chipOrName : chipOrName?.value;
    if (!name || !this.competencies) {
      return false;
    }
    return this.competencies.some(r => r.Name === name);
  }

  validateForm(): boolean {
    const competencyCount = this.competencies?.length ?? 0;
    if (competencyCount < 2 || competencyCount > 20) {
      this.showErrors = true;
      document.getElementsByTagName("mat-sidenav-content")[0]?.scrollTo(0, 0);
      return false;
    }
    if (!this.isValidCompetenciesForLater()) {
      return false;
    }
    this.showErrors = false;
    return true;
  }

  openConfirmationDialog(competency: Competency, chip: MatChipOption) {
    const confirm = new ConfirmDialog();
    confirm.title = "Remove Competency from Plan?";
    confirm.message = "Are you sure you want to remove this competency from your plan?";
    confirm.message2 = "Your self-assessment, learning activities, notes, and reflections for this competency will be removed from your plan."
    confirm.message3 = "You can also return this competency to your list of saved competencies.";
    confirm.okButtonTitle = "Remove";
    confirm.thirdButtonTitle = "Save for Later"
    confirm.cancelButtonTitle = "Cancel";
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '620px',
      panelClass: 'pending-changes',
      data: confirm,
      disableClose: true,
      ariaLabelledBy: 'confirm-desc'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'ok') {
        this.competencyService.deleteCompetency(competency).subscribe(() => {
          _.remove(this.competencies, function (n) { return n.Id === competency.Id });
        });
      chip.toggleSelected();
      }
      if (result === 'third') {
        if(this.saveCompetencyForLater(competency))
          chip.toggleSelected();
      }
    });
  }

  openCustomCompetencyConfirmationDialog(competency: Competency) {
    const confirm = new ConfirmDialog();
    confirm.title = "Remove Competency from Plan?";
    confirm.message = "Are you sure you want to remove this competency from your plan?";
    confirm.message2 = "Your self-assessment, learning activities, notes, and reflections for this competency will be removed from your plan."
    confirm.message3 = "You can also return this competency to your list of saved competencies.";
    confirm.okButtonTitle = "Remove";
    confirm.thirdButtonTitle = "Save for Later"
    confirm.cancelButtonTitle = "Cancel";
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '620px',
      panelClass: 'pending-changes',
      data: confirm,
      disableClose: true,
      ariaLabelledBy: 'confirm-desc'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'ok') {
        this.competencyService.deleteCompetency(competency).subscribe(() => {
          _.remove(this.competencies, function (n) { return n.Id === competency.Id });
        });
      }
      if (result === 'third') {
        this.saveCompetencyForLater(competency);
      }
    });
  }

  getOtherCompetencies(): Competency[] {
    return this.competencies.filter(r => r.Domain === "Other");
  }

  addOtherCompetency() {
    if((this.allCompetencies.filter(r => r.Name.toUpperCase() === this.addCustomCompetency.toUpperCase()))?.length > 0){
      this.openDuplicateDialog();
    }else{
      const competency = { Name: this.addCustomCompetency, Domain: 'Other',
        Id: '0',
        PlanId: this.planId,
        UserId: '0',
        Rating: null,
        ReflectionRating: null,
        ReflectionNotes: null,
        ActivityNote: null,
        Order: this.competencies.length + 1,
        Activities: [],
        Version: this.planEditService.getIsEditing() ? -1 : 0,
        addedFromSavedCompetency: false };
      this.competencyService.createCompetencyByPlanId(competency, this.planId).subscribe((r) => {
        this.competencies.push(r);
        this.allCompetencies.push({Name: this.addCustomCompetency, Domain: 'Other', Description: "", Checked: null})
        this.addCustomCompetency = null;
      });
      this.cdr.detectChanges();
    }

  }

  addSavedCompetency(competency: Competency) {
    const itemAlreadyExists = this.competencies.find(r => r.Name === competency.Name);
    if(itemAlreadyExists){
      this.openAddExistingSavedCompetencyDialog(competency);
    }else{
      competency.addedFromSavedCompetency = true;
        competency.PlanId = this.planId;
        competency.UserId = null;
        competency.Order = this.competencies.length + 1;
        this.competencyService.updateCompetency(competency).subscribe(() => {
          _.remove(this.savedCompetencies, function (n) { return n.Id === competency.Id });
          this.competencies.push(competency);
        })
      this.focusButton();
    }
  }

  chipRemove(chip: Competency) {
    if(this.competencies?.filter(r => r.Name == chip.Name).length > 0 || chip.addedFromSavedCompetency)
    {
      this.openCustomCompetencyConfirmationDialog(chip);
    }
    else
    {
      this.competencyService.deleteCompetency(chip).subscribe(() => {
        _.remove(this.competencies, function (n) { return n.Id === chip.Id });
      });
    }
    this.cdr.detectChanges();
  }

  deleteSavedCompetency(competency: Competency) {
    this.openRemoveSavedCompetencyDialog(competency);
  }

  openLearnMoreDialog(comp_name: string) {
    this.dialog.open(DialogLearnMoreComponent, {
      width: '875px',
      height: 'auto',
      maxHeight: '80vh',
      panelClass: 'learn-more',
      ariaLabel: 'Learn more about each competency',
      data: {
        comp_name: comp_name
      },
      disableClose: true
    });
  }

  openDuplicateDialog() {
    const confirm = new ConfirmDialog();
    confirm.title = "Cannot add duplicate competencies";
    confirm.message = "You are unable to add this competency as it is already listed with an other domain or is in your custom competency list";
    confirm.message2 = ""
    confirm.okButtonTitle = "OK";
    confirm.cancelButtonTitle = "";
    this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '350px',
      data: confirm,
      disableClose: true,
      ariaLabelledBy: 'confirm-desc'
    });
  }

  openRemoveSavedCompetencyDialog(competency: Competency) {
    const confirm = new ConfirmDialog();
    confirm.title = "Remove Saved Competency?";
    confirm.message = "Are you sure you want to remove this saved competency?";
    confirm.message2 = "Your self-assessment, learning activities, and notes saved with this competency will be removed."
    confirm.okButtonTitle = "Remove";
    confirm.cancelButtonTitle = "Cancel";
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '425px',
      height: '360px',
      data: confirm,
      disableClose: true,
      ariaLabelledBy: 'confirm-desc'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'ok') {
        this.competencyService.deleteCompetency(competency).subscribe({next: () => {
          _.remove(this.savedCompetencies, function (n) { return n.Id === competency.Id });
          this.focusButton();
        }})
      }
    });
  }

  openAddExistingSavedCompetencyDialog(competency: Competency) {
      const confirm = new ConfirmDialog();
      confirm.title = "Add Saved Competency";
      confirm.message = "You have previously saved this competency. The corresponding learning activities and notes have been added to your plan. You will still be able to edit this information in the subsequent steps.";
      confirm.message2 = ""
      confirm.okButtonTitle = "OK";
      confirm.cancelButtonTitle = "";
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '425px',
        height: '325px',
        data: confirm,
        disableClose: true,
        ariaLabelledBy: 'confirm-desc'
      });
      dialogRef.afterClosed().subscribe(() => {
        competency.addedFromSavedCompetency = true;
        competency.PlanId = this.planId;
        competency.UserId = null;
        competency.Order = this.competencies.length + 1;
        this.competencyService.updateCompetency(competency).subscribe(() => {
          _.remove(this.savedCompetencies, function (n) { return n.Id === competency.Id });
          this.competencies.push(competency);
        })
        if(this.savedCompetencies?.length > 0){
          this.focusButton();
        }else{
          this.text.nativeElement.focus();
        }
      });
    }

    trackItem(index: any, item: any) {
      return item.name;
    }

    focusButton(): void {
      setTimeout(() => {
        if(this.savedCompetencies?.length > 0){
          this.buttons.forEach((item) => {
            if(item.nativeElement.name == this.savedCompetencies[this.savedCompetencies.length-1].Name){
              item.nativeElement.focus();
            }
          });
        }else{
          this.nextButton.focus();
        }
      }, 500);
    }

  saveCompetencyForLater(competency: Competency): boolean {
    if (!this.canSaveCompetencyForLater()) {
      return false;
    }
    this.userService.user().subscribe({
      next: (user) => {
        competency.UserId = user.Id;
        competency.PlanId = null;
        this.competencyService.updateCompetencyByUserId(competency).subscribe({
          next: (competency) => {
            _.remove(this.competencies, function (n) {
              return n.Id === competency.Id;
            });
            //_.remove(this.workingCompetencies, function (n) { return n.Id === competency.Id})
            this.savedCompetencies.push({...competency});
            this.cdr.detectChanges();
          },
        });
      },
    });
    return true;
  }

  private canSaveCompetencyForLater(): boolean {
    const canSaveCompetencyForLater = this.savedCompetencies?.length + 1 <= Constants.MAXIMUM_SAVED_COMPETENCIES;
    if (!canSaveCompetencyForLater) {
      this.errorMessage = Constants.SAVE_FOR_LATER_COMPETENCY_ERROR_MESSAGE;
      this.errorSection.nativeElement.scrollIntoView({block: "center"});
      return false;
    }
    this.errorMessage = null;
    return true;
  }

  private isValidCompetenciesForLater(): boolean {
    const isSaveCompetencyLimit = this.savedCompetencies?.length <= Constants.MAXIMUM_SAVED_COMPETENCIES;
    if (!isSaveCompetencyLimit) {
      this.errorMessage = Constants.SAVE_FOR_LATER_COMPETENCY_ERROR_MESSAGE;
      this.errorSection.nativeElement.scrollIntoView({block: "center"});
      return false;
    }
    this.errorMessage = null;
    return true;
  }
}
